import { createContext,useEffect,useReducer } from "react";

export const AdminAuthContext = createContext();

export const authReducer = (state,action) => {

    switch(action.type)
    {
        case 'ADMIN_LOGIN':
        return {admin: action.payload}

        case 'ADMIN_LOGOUT':
            return {
                admin:null,
            }

        default:
            return state;    
    }
}

export const AdminAuthContextProvider = ({children}) => {
    const [state,dispatch] = useReducer(authReducer,{
        admin:null
    });

    useEffect(()=>{
        const admin = JSON.parse(localStorage.getItem('admin'));
        if(admin){
            dispatch({type:'ADMIN_LOGIN', payload:admin});
        }

    },[]);

    console.log('AdminAuthContext State ', state);

    return (
        <AdminAuthContext.Provider value={{...state,dispatch}}>
            {children}
        </AdminAuthContext.Provider>
    )
}